module.exports = __webpack_public_path__ + "img/downarw.b3f30465.svg";